const images = import.meta.glob("../img/*.{jpg,png}", { eager: true, import: "default" })

function img(name) {
  const entry = Object.entries(images).find(([path]) => path.endsWith("/" + name))
  if (!entry) throw new Error("Image not found: " + name)
  return entry[1]
}

const playlistData = {
  playlist: [
    {
      name: "Promenade de la Musique",
      date: new Date("2025-06-21"),
      nameParams: "fdlm",
      cover: img("fdlm-1.png"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/promenade-de-la-musique',
          picture: img("fdlm-1.png"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/nUSm_HL9chg',
          picture: img("fdlm-1.png"),
          plateform: "youtube",
          name: "Mix & Promenade",
          other: true
        },
      ],
    },
    {
      name: "Promenade Radio #2",
      date: new Date("2025-04-26"),
      nameParams: "promenade-radio-2",
      cover: img("pr2.png"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/promenade-radio-2',
          picture: img("pr2.png"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/-Oyq6NeDTQk',
          picture: img("pr2.png"),
          plateform: "youtube",
          name: "Mix & Promenade",
          other: true
        },
      ],
    },
    {
      name: "Promenade Radio #1",
      date: new Date("2025-03-06"),
      nameParams: "promenade-radio-1",
      cover: img("pr1.png"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/promenade-radio-1',
          picture: img("pr1.png"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/Mlb34to2BLc',
          picture: img("pr1.png"),
          plateform: "youtube",
          name: "Mix & Promenade",
          other: true
        },
      ],
    },
    {
      name: "Carte de Visite #1",
      date: new Date("2025-07-11"),
      nameParams: "carte-de-visite-1",
      cover: img("cdv1.png"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/carte-de-visite-1-rap-house-club',
          picture: img("cdv1.png"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/SGHrKVi4z9g',
          picture: img("cdv1.png"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix #8",
      date: new Date("2025-07-11"),
      nameParams: "randomix-8",
      cover: img("mix11.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-8',
          picture: img("mix11.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/_pWQiK2NRhg',
          picture: img("mix11.jpg"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix #7",
      date: new Date("2025-05-29"),
      nameParams: "randomix-7",
      cover: img("mix10.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-7',
          picture: img("mix10.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/2cXnUrtPJJY',
          picture: img("mix10.jpg"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix #6",
      date: new Date("2025-05-23"),
      nameParams: "randomix-6",
      cover: img("mix9.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-6',
          picture: img("mix9.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/nakYidSO-b8',
          picture: img("mix9.jpg"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix #5",
      date: new Date("2025-04-25"),
      nameParams: "randomix-5",
      cover: img("mix8.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-5',
          picture: img("mix8.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/NdvEQus_no8',
          picture: img("mix8.jpg"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix #4",
      date: new Date("2025-02-09"),
      nameParams: "randomix-4",
      cover: img("mix7.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-4',
          picture: img("mix7.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/zKiQf_alOJw',
          picture: img("mix7.jpg"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix NYE",
      date: new Date("2025-01-01"),
      nameParams: "randomix-nye",
      cover: img("MixNYE.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-nye',
          picture: img("MixNYE.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/DIUjbbqh154',
          picture: img("MixNYE.jpg"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix #3",
      date: new Date("2024-11-11"),
      nameParams: "randomix-3",
      cover: img("mix6.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-3',
          picture: img("mix6.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/ibV7Q8Yiyvo',
          picture: img("mix6.jpg"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix #2",
      date: new Date("2024-10-27"),
      nameParams: "randomix-2",
      cover: img("mix5.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-2',
          picture: img("mix5.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/_y4SxXm3cWA',
          picture: img("mix5.jpg"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Randomix #1",
      date: new Date("2024-09-29"),
      nameParams: "randomix-1",
      cover: img("mix4.png"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/randomix-1',
          picture: img("mix4.png"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/_MUXgMpCfhM',
          picture: img("mix4.png"),
          plateform: "youtube",
          name: "Mix & Visualizer",
          other: true
        },
      ],
    },
    {
      name: "Chipie Club - House Rap",
      date: new Date("2024-09-26"),
      nameParams: "chipie-club-2",
      cover: img("mixHouseYT.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/chipie-club-mix-house-rap',
          picture: img("mixHouseSC.jpg"),
          plateform: "soundcloud",
          name: "Mix",
          other: true
        },
        {
          link: 'https://youtu.be/h_nD4ZemYu8',
          picture: img("mixHouseYT.jpg"),
          plateform: "youtube",
          name: "Mix",
          other: true
        },
      ],
    },
    {
      name: "Chipie Club - 21/08/2024",
      date: new Date("2024-08-30"),
      nameParams: "chipie-club-1",
      cover: img("mix3SC.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://on.soundcloud.com/1Ycp5Ap1tzCkjCpd8',
          picture: img("mix3SC.jpg"),
          plateform: "soundcloud",
          name: "Mix only",
          other: true
        },
        {
          link: 'https://youtu.be/G5JgUa-QKC8',
          picture: img("mix3YT.jpg"),
          plateform: "youtube",
          name: "VJ & Mix",
          other: true
        },
      ],
    },
    {
      name: "VJing & Mixing Session #2",
      date: new Date("2024-08-18"),
      nameParams: "vjing-mixing-session-2",
      cover: img("mix2YT.jpg"),
      type: "mix",
      data: [
        {
          link: 'https://soundcloud.com/etidou/mix-2',
          picture: img("mix2SC.jpg"),
          plateform: "soundcloud",
          name: "Mix only",
          other: true
        },
        {
          link: 'https://youtu.be/aNAXXapUkuc',
          picture: img("mix2YT.jpg"),
          plateform: "youtube",
          name: "VJ & Mix",
          other: true
        },
      ],
    },
    {
      name: "VJing & Mixing Session #1",
      date: new Date("2024-07-14"),
      nameParams: "vjing-mixing-session-1",
      cover: img("mix1YT.jpg"),
      data: [
        {
          link: 'https://soundcloud.com/etidou/mix-1',
          picture: img("mix1SC.jpg"),
          plateform: "soundcloud",
          name: "Mix only",
          other: true
        },
        {
          link: 'https://www.youtube.com/watch?v=-FXAzZUjHVE',
          picture: img("mix1YT.jpg"),
          plateform: "youtube",
          name: "VJ & Mix",
          other: true
        },
      ],
    },
    {
      name: "Lille VJ Fest 2024",
      nameParams: "live-vj-set",
      cover: img("mix.jpg"),
      type: "mix",
      date: new Date("2024-05-11"),
      data: [
        {
          link: 'https://soundcloud.com/etidou/sets/lille-vj-fest-2024-mix',
          picture: img("mix.jpg"),
          plateform: "soundcloud",
          name: "Lille VJ Fest 2024 Playlist",
          other: true
        },
        {
          link: 'https://youtu.be/LheXuMiS1hk',
          picture: img("mix.jpg"),
          plateform: "youtube",
          name: "Lille VJ Fest 2024 Mix",
          other: true
        },
      ],
    },
    {
      name: "Son du Jour - Saison 2'",
      nameParams: "sdj2",
      date: new Date("2026-09-26"),
      type: "playlist",
      cover: img("SDJ2.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/son-du-jour-saison-2/pl.u-r2yBJrqtP6o0DZr',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/2EH5OOSgYg0bJLtNm8RDio?si=0b0091afa31c4ff3',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/34vxAk2WsD09IB4c6kdWC',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Son du Jour - Saison 1'",
      nameParams: "sdj1",
      date: new Date("2025-08-22"),
      type: "playlist",
      cover: img("SDJ1.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/son-du-jour-saison-1/pl.u-r2yBJJ4FP6o0DZr',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/10ENsvnlAROEAPD4FAMi4p?si=f082fba0a3034492&pt=01bd14f1be2188db7e716946622f9170',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/30P8oP7KUcup8vuYFPmWi',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Septembre 26'",
      nameParams: "septembre-26",
      date: new Date("2026-10-08"),
      type: "playlist",
      cover: img("September26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-septembre-26/pl.u-4JomzrGTagp1qPN',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/0OFyeX3l5gE0jpdfU9rosJ?si=58a93ed09dd74051',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/34xIl2GJwMHZGf4O9elzQ',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Aout 26'",
      nameParams: "aout-26",
      date: new Date("2026-09-01"),
      type: "playlist",
      cover: img("Aout26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-aout-26/pl.u-qxylAkBT2Z1xoD9',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/11y3p7sQNqxpSnRYsdauXF?si=510eba21b40641fb',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/34fCUpXIFZgnYNLcPX7PE',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Juillet 26'",
      nameParams: "juillet-26",
      date: new Date("2026-08-01"),
      type: "playlist",
      cover: img("July26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-juillet-26/pl.u-55D6z22I8qZ2ArB',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/3zQetlpcly9jO5g3gq2jHi?si=c9c1e200bd0f437e',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/33ZbODsP3Uyvz4axsVZEl',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Juin 26'",
      nameParams: "juin-26",
      date: new Date("2026-07-03"),
      type: "playlist",
      cover: img("June26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-juin-26/pl.u-zPyLAagsZmv2VqP?l=en-GB',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/7xz3CkyRxSGLOwwgjq7P56?si=f7310538a1df4da6',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/33IGdg6E7rVfObzkG3Y3D',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Mai 26'",
      nameParams: "mai-26",
      date: new Date("2026-06-02"),
      type: "playlist",
      cover: img("May26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-mai-26/pl.u-yZyVDNLuYMJmL1a',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/7wIVHI8CViHiRnF1ScP1Ea?si=a0472acf067e4451',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/33rk4tVJ6ldfpeSy9uMAJ',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Avril 26'",
      nameParams: "avril-26",
      date: new Date("2026-05-01"),
      type: "playlist",
      cover: img("April26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-avril-26/pl.u-XkD0Y6pTDpxLMya?l=en',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/3rLc6VH34KeTrXmklaUxRr?si=d8b620e09ae74299',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/338G5GgbPxQyG9eYM73e5',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Mars 26'",
      nameParams: "mars-26",
      date: new Date("2026-04-02"),
      type: "playlist",
      cover: img("March26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-mars-26/pl.u-MDAWeL9uW5vg1kL',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/4mG9UP6CPtSI7ZQN7SNziT?si=cd252de0c2104e3f',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/32S7VZ7z9iA27uQjBKAKM',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Fevrier 26'",
      nameParams: "fevrier-26",
      date: new Date("2026-03-01"),
      type: "playlist",
      cover: img("Febuary26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-fevrier-26/pl.u-XkD0YE0hDpxLMya',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/30NvjhVTjOOBWhFleVVK6D?si=06d4e7ba38484821',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/32Ayfuaj7jO8K65mVBdcA',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Janvier 26'",
      nameParams: "janvier-26",
      date: new Date("2026-02-01"),
      type: "playlist",
      cover: img("January26.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-janvier-26/pl.u-MDAWeGjsW5vg1kL',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/3t3cbsnamI0UllwWGGoIA6?si=73ba59cc024444cd',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/32kr9Nz8baMgfGbe26mrX',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Decembre 25'",
      nameParams: "decembre-25",
      date: new Date("2026-01-01"),
      type: "playlist",
      cover: img("December25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-decembre-25/pl.u-EdAVvaeuaZyek6B',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/2Gvri5lbQFbZOdTdZuqZbu?si=70ef270fbb9e4077',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/322YeJrNvomO7hPUKllUQ',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Novembre 25'",
      nameParams: "novembre-25",
      date: new Date("2025-12-08"),
      type: "playlist",
      cover: img("November25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/d%C3%A9couverte-novembre-25/pl.u-r2yBJ3YTP6o0DZr',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/4YYQ0atteulcIx7NWWl7sQ?si=d1cdc63c2f294867',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/31ObqDu3cYzqBKvYTgqz8',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Octobre 25'",
      nameParams: "octobre-25",
      date: new Date("2025-11-02"),
      type: "playlist",
      cover: img("October25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-octobre-25/pl.u-r2yBJPPFP6o0DZr',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/0kZidyPxGCEOQPmh9yGh0V?si=1d0a5ac9d6e74e93',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/31uBpwFG1slECYglZkkiJ',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Septembre 25'",
      nameParams: "septembre-25",
      date: new Date("2025-10-04"),
      type: "playlist",
      cover: img("September25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/d%C3%A9couverte-septembre-25/pl.u-pMylDjYf49vkANE',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/3c6yRteCBlR1bchgscZWWu?si=65da38d81cee4072',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/31e3aTDOy0inj5qriJ8h0',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Aout 25'",
      nameParams: "aout-25",
      date: new Date("2025-09-01"),
      type: "playlist",
      cover: img("August25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-aout-25/pl.u-pMylDJvc49vkANE',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/71QzIqe3VdxmbDp19ATjjz?si=24376e2cc4e0412b',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/30V5pdRaoe8gHe6oXUaLe',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Juillet 25'",
      nameParams: "juillet-25",
      date: new Date("2025-08-01"),
      type: "playlist",
      cover: img("July25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-juillet-25/pl.u-55D6PP5c8qZ2ArB',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/4y1PsZqpkBoTmo1JK0HNnW?si=975732dc58c544cd',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://link.deezer.com/s/30Dd8CfQ0NSwfbK3ZZiIw',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Juin 25'",
      nameParams: "juin-25",
      date: new Date("2025-07-02"),
      type: "playlist",
      cover: img("June25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-juin-25/pl.u-r2yBJ5YtP6o0DZr',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/34IU9mfhjd6AtFTTqPTyUy?si=61739d1454bd41c1',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://www.deezer.com/fr/playlist/13983017941',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Mai 25'",
      nameParams: "mai-25",
      date: new Date("2025-06-01"),
      type: "playlist",
      cover: img("May25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-mai-25/pl.u-55D6P8Vt8qZ2ArB',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/0ORL6rvQtTJNBv08AVidft?si=3ffd08e3ee174de0',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://dzr.page.link/7q19aeMXEKdTUNN4A',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Avril 25'",
      nameParams: "avril-25",
      date: new Date("2025-05-02"),
      type: "playlist",
      cover: img("April25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-avril-25/pl.u-qxyl0vxC2Z1xoD9',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/0okCj2Ol2GXbgIwIWKXWoR?si=2d243f64dcf54ea3',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://dzr.page.link/q5RDMrvZaiSeWS5R8',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Mars 25'",
      nameParams: "mars-25",
      date: new Date("2025-04-01"),
      type: "playlist",
      cover: img("March25.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-mars-25/pl.u-zPyL1pYuZmv2VqP',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/2JeHR6Zs3Bf5VdhktAIbDC?si=fb5a289bf8d840ec',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://dzr.page.link/AKHoB5fW6MtChLDbA',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Février 25'",
      nameParams: "fevrier-25",
      date: new Date("2025-03-01"),
      type: "playlist",
      cover: img("Febuary.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-fevrier-25/pl.u-yZyVP2VFYMJmL1a',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/5xPNnxoma7lWg6znspmsXw?si=a0257c89795443a16',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://dzr.page.link/R3om9ijXFcLyHrNP6',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Janvier 25'",
      nameParams: "janvier-25",
      date: new Date("2025-02-05"),
      type: "playlist",
      cover: img("January.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-janvier-25/pl.u-XkD0YzMfDpxLMya',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/2wnQX9xRFjpJn163kNEBas?si=e8956b0f52d34136',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/69KmaQk7LrsWk4NDA',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Decembre 24'",
      nameParams: "decembre-24",
      date: new Date("2025-01-02"),
      type: "playlist",
      cover: img("December.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-decembre-24/pl.u-4Jomme3Cagp1qPN',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/2PujQjdiCLcV3agOE4Pq1P?si=66164338556c4006',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/eYvGcP7T8wvQJntP9',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Novembre 24'",
      nameParams: "novembre-24",
      date: new Date("2024-12-01"),
      type: "playlist",
      cover: img("November.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-novembre-24/pl.u-yZyVVYXFYMJmL1a',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/2YmlL8lZLj5XZbJl6oDuvE?si=0cfd1959fae049e6',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/tfMq2K2VTULXPTF67',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Octobre 24'",
      nameParams: "octobre-24",
      date: new Date("2024-11-01"),
      type: "playlist",
      cover: img("October.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-octobre-24/pl.u-XkD00bECDpxLMya',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/6G9ntTPTIPk4JofJATUCMf?si=2709f2d25bf140b7',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/qfHNME7qaDXm7B9T8',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Septembre 24'",
      nameParams: "septembre-24",
      date: new Date("2024-10-01"),
      type: "playlist",
      cover: img("September.png"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-septembre-24/pl.u-06oxxYyIWvN5kZA',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/3cWnOynYDitFbRmEAWKLyh?si=07abf12012154722',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/53QyjFkBfxnDEkQj7',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Aout 24'",
      nameParams: "aout-24",
      date: new Date("2024-09-01"),
      type: "playlist",
      cover: img("August.jpg"),
      data: [
        {
          link: 'https://music.apple.com/us/playlist/decouverte-aout-24/pl.u-EdAVVl4uaZyek6B',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/3aoGviAMUTBL2emvLm4yxl?si=3723e3a1e72546ee',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/fNnF1ateiyVSTRqWA',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Juillet 24'",
      nameParams: "juillet-24",
      date: new Date("2024-08-06"),
      type: "playlist",
      cover: img("July.jpg"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-juillet-24/pl.u-r2yBBYBFP6o0DZr',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/1VbMtcNK9eEwUgnzxWLJBP?si=8339423b2ac14ff1',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/4UNNc9uCDxEBL2fJA',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Juin 24'",
      nameParams: "juin-24",
      date: new Date("2024-07-01"),
      type: "playlist",
      cover: img("June.jpg"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-juin-24/pl.u-pMyllgvF49vkANE',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/0TWj7rj5crMgywKp06r5Tx?si=05ed14afcbad46b7',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/Fq4m2KESF3X47Khg7',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Mai 24'",
      nameParams: "mai-24",
      date: new Date("2024-06-01"),
      type: "playlist",
      cover: img("May.jpg"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-mai-24/pl.u-r2yBBDXtP6o0DZr',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/6ZxjKLj7ZjuGtGzJSlGRl4?si=cb951201bb1f48ac',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/DKR7jhDSqFzacFWk8',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Avril 24'",
      nameParams: "avril-24",
      date: new Date("2024-05-01"),
      type: "playlist",
      cover: img("April.jpg"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-avril-24/pl.u-4Jomm9DIagp1qPN',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/7ivoMqz3Vjlg1EdfvzuXez?si=eb18014dccf14686',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/SCw1BYWpmnNZV9CN7',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    },
    {
      name: "Decouverte Mars 24'",
      nameParams: "mars-24",
      date: new Date("2024-04-01"),
      type: "playlist",
      cover: img("March.jpg"),
      data: [
        {
          link: 'https://music.apple.com/fr/playlist/decouverte-mars-24/pl.u-zPyLLRXFZmv2VqP',
          plateform: "apple",
          name: "Apple Music"
        },
        {
          link: 'https://open.spotify.com/playlist/5F3DahB4unUJrEABtKsPWO?si=47baedb789dd40a1',
          plateform: "spotify",
          name: "Spotify"
        },
        {
          link: 'https://deezer.page.link/Cv1X3Ye7SYnqoTns9',
          plateform: "deezer",
          name: "Deezer"
        },
      ],
    }
  ]
}

export default playlistData 